import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VModal from 'vue-js-modal';
import axios from 'axios';

import VueSimpleAlert from 'vue-simple-alert';
import VueVideoPlayer from 'vue-video-player';
import VideoPlayerLand from '../src/components/VideoPlayerLand.vue';
import VideoPlayer from '../src/components/VideoPlayer.vue';
import Detail from '../src/components/Detail.vue';
import Purchase from '../src/components/Purchase.vue';
import Form from '../src/components/Form.vue';
import Agreement from '../src/components/Agreement.vue';
import AgreementLanguage from '../src/components/AgreementLanguage.vue';
import Privacy from '../src/components/Privacy.vue';
import Player from '../src/components/Player.vue';
import About from '../src/components/About.vue';
import DreamITS from '../src/components/DreamITS.vue';
import ToolAgreement from '../src/components/DreamToolAgreement.vue';
import Files from '../src/components/Files.vue';
import FilesSource from '../src/components/FilesSource.vue';
import Login from '../src/components/Login.vue';
import Selection from '../src/components/Selection.vue';
import Courseware from '../src/components/Courseware.vue';
import DreamPDF from '../src/components/DreamPDF.vue';
import DreamPDF2 from '../src/components/DreamPDF2.vue';
import MentPlan from '../src/components/MentPlan.vue';
import MentMPlan from '../src/components/MentPlanM.vue';
import Ment from '../src/components/Ment.vue';
import Language from '../src/components/Language.vue';
import DreamC from '../src/components/DreamC.vue';
import Certificate from '../src/components/Certificate';
import CerCanvas from '../src/components/CertificateCanvas';
import Santong from '../src/components/Santong.vue';
import PPTDemo from '../src/components/2PPT.vue';
import PPTDemo3 from '../src/components/3PPT.vue';
import IMControl from '../src/components/IMControl.vue';
import SwamReport from '../src/components/SwamReport.vue';
import ChildCreate from './components/ChildCreate.vue';
import SwamtStart from './components/SwamtStart.vue';
import SwamtReport from './components/SwamtReport.vue';
import SwamtStart25 from './components/SwamtStart25.vue';
import SwamtStartParent25 from './components/SwamtStartParent25.vue';
import SwamtReportParent from './components/SwamtReportParent.vue';
import LanguageMessage from './components/LanguageMessage.vue';
import AllParentMessages from './components/AllParentMessages.vue';
import AllMessages from './components/AllMessages.vue';
import ParentMessage from './components/ParentMessage.vue';

import 'vue-video-player/node_modules/video.js/dist/video-js.css';
import VueQRCodeComponent from 'vue-qrcode-component';
import VueNotification from 'vue-notification';

Vue.use(VueRouter);
Vue.use(VueSimpleAlert);
Vue.use(VueVideoPlayer);
Vue.use(VModal, {dialog: true});
Vue.use(VueNotification);
Vue.component('qr-code', VueQRCodeComponent);
Vue.config.productionTip = true;
Vue.prototype.axios = axios;
Vue.prototype.apiBaseUrl = 'https://bethelparentws.bethelonline.cn/api/';

const routes = [
    {path: '/', redirect: '/detail'},
    {
        path: '/video_player_land',
        component: VideoPlayerLand,
    },
    {
        path: '/certificate',
        component: Certificate,
    },
    {
        path: '/certificate_canvas',
        component: CerCanvas,
    },
    {
        path: '/language_agreement',
        component: AgreementLanguage,
    },
    {path: '/video_player', component: VideoPlayer},
    {path: '/Purchase', component: Purchase},
    {path: '/detail', component: Detail},
    {path: '/form', component: Form},
    {path: '/agreement', component: Agreement},
    {path: '/privacy', component: Privacy},
    {path: '/player', component: Player},
    {path: '/about', component: About},
    {path: '/dream_its', component: DreamITS},
    {path: '/ment', component: Ment},
    {path: '/m_ment_plan', component: MentMPlan},
    {path: '/language', component: Language},
    {path: '/tool_agreement', component: ToolAgreement},
    {path: '/files', component: Files},
    {path: '/files_sources', component: FilesSource},
    {path: '/login', component: Login},
    {path: '/selection', component: Selection},
    {path: '/courseware', component: Courseware},
    {path: '/dreampdf2', component: DreamPDF2},
    {path: '/dreampdf', component: DreamPDF},
    {path: '/dreamc', component: DreamC},
    {path: '/ment_plan', component: MentPlan},
    {path: '/san_tong', component: Santong},
    {path: '/ppt_demo_2', component: PPTDemo},
    {path: '/ppt_demo_3', component: PPTDemo3},
    {
        path: '/im_control_2',
        component: IMControl,
    },
    {
        path: '/swam_report',
        component: SwamReport,
    },
    {
        path: '/child_create',
        component: ChildCreate,
    },
    {
        path: '/swamt_start',
        component: SwamtStart,
    },
    {
        path: '/swamt_start_25',
        component: SwamtStart25,
    },
    {
        path: '/swamt_start_parent_25',
        component: SwamtStartParent25,
    },
    {
        path: '/swamt_report_parent/:test_id',
        component: SwamtReportParent,
    },
    {
        path: '/swamt_report/:test_id',
        component: SwamtReport,
    },
    {
        path: '/language_message/:language_id',
        name: 'language_message',
        component: LanguageMessage,
    },
    {
        path: '/all_messages',
        component: AllMessages,
        name: 'all_messages',
    },
    {
        path: '/parent_message/:language_id',
        name: 'parent_message',
        component: ParentMessage,
    },
    {
        path: '/all_parent_messages',
        component: AllParentMessages,
        name: 'all_parent_messages',
    },
];

const router = new VueRouter({
    routes,
});

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
